import React from "react";
import Header from "components/Admin/shared/Table/Header.jsx";

const titles = {
  name: "Name",
  email: "Email",
  accept: "Member Authorisation Required",
  reject: "Cancel Invitations",
  status: "Status",
  actions: "",
};

const additionalProps = {};

const Headers = ({ onChange, value: selectedValue }) => {
  return (
    <tr>
      {/* <th></th> */}
      {Object.keys(titles).map((value) => (
        <Header
          onChange={onChange}
          key={value}
          values={[value]}
          title={titles[value]}
          selected={selectedValue}
          thProps={{ style: { textAlign: "center" } }}
          {...(additionalProps[value] || {})}
        />
      ))}
    </tr>
  );
};

export default Headers;



// WEBPACK FOOTER //
// ./src/components/Admin/StudyGroups/GroupMembers/Headers.jsx